'use client';

import { useEffect } from 'react';
import { trackEvent } from '../../lib/analytics/posthog';
import { EVENTS } from '../../lib/analytics/events';

export default function CityPageTracker({
  categorySlug,
  categoryName,
  provinceSlug,
  provinceName,
  cityName,
  listingCount
}) {
  useEffect(() => {
    trackEvent(EVENTS.CATEGORY_CITY_PAGE_VIEWED, {
      category_slug: categorySlug,
      category_name: categoryName,
      province_slug: provinceSlug,
      province_name: provinceName,
      city_name: cityName,
      listing_count: listingCount
    });
    // Una vista por página montada: si las props cambian (un objeto nuevo en un refresh del RSC), no
    // es otra vista. Cambiar de página remonta el componente.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
